import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useAndReportExperimentTreatment } from '@ms/yammer-hooks/dist/experiments';

import { useIsTeamsPersonalApp } from './selectors';

type UseIsTeamsFullWidthLayoutEnabled = () => boolean;
export const useIsTeamsFullWidthLayoutEnabled: UseIsTeamsFullWidthLayoutEnabled = () => {
  const isTeamsPersonalApp = useIsTeamsPersonalApp();
  const isExperimentEnabled = !!useAndReportExperimentTreatment(Experiment.TeamsSupportFullWidthLayout);

  return isTeamsPersonalApp && isExperimentEnabled;
};
